export const formatStatusBadge = (data) => {
  let statusText = formatStatus(data) || "Cancelled";
  let statusColor =
    statusText == "Issued"
      ? "text-bg-success"
      : statusText == "Freeze"
        ? "text-bg-secondary"
        : statusText == "Cancelled"
          ? "text-bg-danger"
          : "text-bg-warning";

  return (
    <>
      <span
        className={`badge ${statusColor}`}
        style={{ fontSize: "11px" }}
        role="button"
      >
        {statusText}
      </span>
    </>
  );
};

export const formatStatus = (data) => {
  let status = [
    "New",
    "Partial Done",
    "Freeze",
    "Issued",
    "Cancelled",
    "Dispute",
  ];

  return status[Number(data.is_active) - 1];
};

export const formatItemStatus = (data) => {
  let status = ["New", "Partial Done", "Freeze", "Issued", "Cancelled"];
  return status[Number(data.is_active) - 1];
};
export const canShowCheckbox = (data, erpIntegration, exportNewChallan) => {
  const statusText = formatStatus(data);

  const allowedStatus = (exportNewChallan == 1
    ? ["Issued", "Freeze", "New"]
    : ["Issued", "Freeze"]
  ).includes(statusText);
  const isZeroValueAllowed = Number(data?.is_zero_value) === 0;
  const isSyncedToErp = Number(data?.sync_status) === 1;

  if (!allowedStatus || !isZeroValueAllowed) return false;

  if (Number(erpIntegration) === 1 && isSyncedToErp) return false;

  return true;
};

export const formatItemStatusPurchase = (data) => {
  let status = ["Pending", "Approved", "Rejected", "Partial Done"];
  return status[Number(data.status) - 1];  
};


export const uomConversionUnit = (v) => {
  if (v.uom == v.base_uom) {
    return `(${v.alt_qty} ${v.alt_uom})`;
  } else {
    return `(${v.alt_qty} ${v.base_uom})`;
  }
};

export const uomConversion = (v) => {
  if (v.uom == v.base_uom) {
    return `${v.alt_uom}`;
  } else {
    return ` ${v.base_uom}`;
  }
};